/*eslint-disable*/

import React, { useState } from "react";

// Days mapping
const days = [
    { id: 1, label: "L" },
    { id: 2, label: "M" },
    { id: 3, label: "M" },
    { id: 4, label: "J" },
    { id: 5, label: "V" },
    { id: 6, label: "S" },
    { id: 0, label: "D" },
];

const BusinessHoursModal = ({
    toggleModal,
    businessHours,
    onUpdate, // Add this prop to receive the callback
}: {
    toggleModal: () => void;
    businessHours: {
        [key: number]: {
            open_times: { open_time: string; close_time: string }[];
            is_closed: boolean;
            is_24_hours: boolean;
        };
    };
    onUpdate: (updatedHours: any) => void; // Callback type
}) => {
    const [selectedDays, setSelectedDays] = useState<number[]>([]);
    const [editedHours, setEditedHours] = useState(businessHours);

    // Handle time changes (start or end time)
    const handleTimeChange = (
        day: number,
        index: number,
        type: "open_time" | "close_time",
        value: string
    ) => {
        setEditedHours((prev) => {
            const updatedHours = { ...prev };
            selectedDays.forEach((selectedDay) => {
                if (
                    !updatedHours[selectedDay].is_closed &&
                    !updatedHours[selectedDay].is_24_hours
                ) {
                    updatedHours[selectedDay].open_times[index][type] = value;
                }
            });
            // Trigger the callback to notify the parent component of the update
            // onUpdate(updatedHours);
            return updatedHours;
        });
    };

    // Add a new time slot for the selected days
    const addTimeSlot = () => {
        setEditedHours((prev) => {
            const updatedHours = { ...prev };
            selectedDays.forEach((day) => {
                if (
                    updatedHours[day].is_closed ||
                    updatedHours[day].is_24_hours
                ) {
                    // If closed or 24h, replace it with the time slot
                    updatedHours[day].is_closed = false;
                    updatedHours[day].is_24_hours = false;
                    updatedHours[day].open_times = [
                        { open_time: "", close_time: "" },
                    ];
                } else {
                    updatedHours[day].open_times.push({
                        open_time: "",
                        close_time: "",
                    });
                }
            });
            // Trigger the callback to notify the parent component of the update
            // onUpdate(updatedHours);
            return updatedHours;
        });
    };

    // Remove a time slot for the selected days
    const removeTimeSlot = (index: number) => {
        setEditedHours((prev) => {
            const updatedHours = { ...prev };
            selectedDays.forEach((day) => {
                if (
                    !updatedHours[day].is_closed &&
                    !updatedHours[day].is_24_hours
                ) {
                    updatedHours[day].open_times.splice(index, 1);
                }
            });
            // Trigger the callback to notify the parent component of the update
            // onUpdate(updatedHours);
            return updatedHours;
        });
    };

    // Toggle day selection (add/remove from selectedDays array)
    const toggleDaySelection = (id: number) => {
        setSelectedDays((prev) =>
            prev.includes(id) ? prev.filter((day) => day !== id) : [...prev, id]
        );
    };

    const handleSave = () => {
        onUpdate(editedHours); // Send updated hours to the parent component
        toggleModal(); // Close modal
    };

    const handleCheckboxChange = (status) => {
        setEditedHours((prev) => {
            const updatedHours = { ...prev };
            selectedDays.forEach((day) => {
                if (status === "closed") {
                    updatedHours[day] = {
                        is_closed: !updatedHours[day].is_closed,
                        is_24_hours: false,
                        open_times: [],
                    };
                } else if (status === "24_hours") {
                    updatedHours[day] = {
                        is_closed: false,
                        is_24_hours: !updatedHours[day].is_24_hours,
                        open_times: [],
                    };
                }
            });

            return updatedHours;
        });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 w-full h-full">
            <div className="bg-white p-6 rounded-xl shadow-lg w-96">
                <h3 className="text-xl font-semibold mb-4">
                    Modifier les heures
                </h3>
                <p className="mb-4">
                    Sélectionnez les jours et définissez les heures
                    d&rsquo;ouverture.
                </p>

                {/* Day selection buttons */}
                <div className="flex justify-between mb-4">
                    {days.map(({ id, label }) => (
                        <button
                            key={id}
                            className={`w-10 h-10 rounded-full border font-bold ${
                                selectedDays.includes(id)
                                    ? "bg-gold text-black"
                                    : "border-gray-200 text-black"
                            }`}
                            onClick={() => toggleDaySelection(id)}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {/* Status selection buttons (closed or 24h) */}
                {selectedDays.length > 0 && (
                    <div className="mb-4 flex flex-row items-center justify-center">
                        <label className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                checked={editedHours[selectedDays[0]].is_closed}
                                onChange={() => handleCheckboxChange("closed")}
                                className="mr-2"
                            />
                            Fermé
                        </label>
                        <label className="flex items-center w-1/2">
                            <input
                                type="checkbox"
                                checked={
                                    editedHours[selectedDays[0]].is_24_hours
                                }
                                onChange={() =>
                                    handleCheckboxChange("24_hours")
                                }
                                className="mr-2"
                            />
                            Ouvert 24h
                        </label>
                    </div>
                )}

                {/* Time slots */}
                <div className="flex flex-col w-full">
                    {selectedDays.length > 0 &&
                        selectedDays.every(
                            (day) =>
                                !editedHours[day].is_closed &&
                                !editedHours[day].is_24_hours
                        ) && (
                            <>
                                {editedHours[selectedDays[0]].open_times.map(
                                    (slot, index) => (
                                        <div
                                            key={index}
                                            className="flex flex-row items-center mb-2 w-full"
                                        >
                                            <input
                                                type="time"
                                                value={slot.open_time}
                                                onChange={(e) =>
                                                    handleTimeChange(
                                                        selectedDays[0],
                                                        index,
                                                        "open_time",
                                                        e.target.value
                                                    )
                                                }
                                                className="border rounded p-2 mr-2 w-1/2"
                                            />
                                            <input
                                                type="time"
                                                value={slot.close_time}
                                                onChange={(e) =>
                                                    handleTimeChange(
                                                        selectedDays[0],
                                                        index,
                                                        "close_time",
                                                        e.target.value
                                                    )
                                                }
                                                className="border rounded p-2 mr-2 w-1/2"
                                            />
                                            <button
                                                onClick={() =>
                                                    removeTimeSlot(index)
                                                }
                                                className="text-black p-1 rounded"
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    )
                                )}
                            </>
                        )}
                </div>

                {/* Add time slot button */}
                <button
                    onClick={addTimeSlot}
                    className="text-black py-1 px-3 rounded mb-4 font-semibold"
                >
                    Ajouter un créneau horaire
                </button>

                {/* Modal action buttons */}
                <div className="flex justify-end">
                    <button
                        onClick={toggleModal}
                        className="mr-2 bg-gray-100 text-black py-2 px-4 rounded-full"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleSave}
                        className="bg-gold text-black py-2 px-4 rounded-full"
                    >
                        Sauvegarder
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BusinessHoursModal;
